module.exports = __webpack_public_path__ + "static/media/custom.85b25742.jpg";